import { supabase } from '../supabaseClient'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { Point } from '../containers/BookableActivityPage/types'

class LocationService {
  createLocation = async (payload: any): Promise<any> => {
    const locationUUID = uuidv4()

    if (!payload.latitude || !payload.longitude) {
      console.error('Latitude or Longitude missing from google maps response')
      throw Error(`Latitude or Longitude missing from google maps response`)
    }

    const geopoint: Point = this.createPoint(payload.latitude, payload.longitude)
    const { error: insertError } = await supabase
      .from('locations')
      .insert({
        uuid: locationUUID,
        geopoint,
        latitude: payload.latitude,
        longitude: payload.longitude,
        address: payload.address,
        google_place_id: payload.google_place_id,
        created_by: payload.created_by,
      })

    if (insertError) {
      console.error('Error creating location:', insertError)
      throw new Error(`Failed to create location: ${insertError.message}`)
    }

    return locationUUID
  }

  getTimezone = async (payload: any): Promise<any> => {
    const timestampInSeconds = Math.floor(Date.now() / 1000)
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/timezone/json?location=` +
          payload.latitude +
          ',' +
          payload.longitude +
          '&timestamp=' +
          timestampInSeconds +
          '&key=' +
          process.env.REACT_APP_GOOGLE_API_KEY,
      )
      return response.data
    } catch (e) {
      console.log('err', { e })
    }
  }

  createPoint(latitude: string, longitude: string): Point {
    // Note that this is LONGITUDE first
    return `POINT(${longitude} ${latitude})`
  }

  getLocationByUUID = async (uuid: string): Promise<any> => {
    try {
      const { data, error } = await supabase.from('locations').select('*').eq('uuid', uuid)
      if (error) {
        console.error(error)
      }
      return data
    } catch (error) {
      console.error(error)
    }
  }
}

const locationService = new LocationService()

export default locationService
